import React from "react";
import CategoryGridMobile from "./AnimaliacatMobile"; // your first component (responsive)
import CategoryGridWeb from "./AnimaliaCategorySection";       // your second component (desktop)
import "../css/CategorySection.css";

const CategorySection = () => {
  return (
    <>
      <div className="mobile-only">
        <CategoryGridMobile />
      </div>

      <div className="web-only">
        <CategoryGridWeb />
      </div>
    </>
  );
};

export default CategorySection;
